module.exports = __webpack_public_path__ + "assets/icons/big.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/bags/big.png
// module id = ./src/styles/icons/bags/big.png
// module chunks = 0